import styled from "styled-components";

export const SummaryContainer = styled.div<{ $fontSize: number }>`
  align-self: stretch;
  display: flex;
  align-items: center;
  padding-inline: 8px;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: ${({ $fontSize }) => $fontSize}px;
`;

export const SummaryItems = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: fit-content;

  @media screen and (max-width: 620px) {
    font-size: 14px;
    items-align: baseline;
  }
  @media screen and (max-width: 590px) {
    font-size: 12px;
  }
  @media screen and (max-width: 520px) {
    font-size: 10px;
    gap: 4px;
    align-items: baseline;
  }
`;
